const data = [
  {
    id: 1,
    text: "about",
    url: "/about",
  },

  {
    id: 3,
    text: "contact",
    url: "/contact",
  },
  {
    id: 4,
    text: "posts",
    url: "/posts",
  },
  {
    id: 5,
    text: "Privacy policy",
    url: "/privacy",
  },
];

export default data;
